<template>
  <v-app-bar v-show="toolbarVisibile" app class="header">
    <v-card>
      <v-row class="d-flex align-stretch">
        <v-col cols="4">
          <v-btn class="btn_logo" text to="/">
            <img class="logo" :src="require('@/assets/logo.svg')" />
          </v-btn>
        </v-col>
        <v-col class="header_steps d-flex">
          <v-row>
            <v-btn
              :class="{ 'col-3': true, active: step > 0 }"
              :disabled="step < 1"
              text
              to="/start"
              v-text="$t('global.start')"
            >
            </v-btn>
            <v-btn
              :class="{ 'col-3': true, active: step > 1 }"
              :disabled="step < 2 || explainId == null"
              text
              :to="`/explainable/${explainId}`"
              v-text="$t('global.explainable')"
            ></v-btn>
            <v-btn
              :class="{ 'col-6': true, active: step > 2 }"
              :disabled="step < 3 || optimizeId == null"
              text
              :to="`/optimization/${optimizeId}`"
              v-text="$t('global.optimization')"
            ></v-btn>
          </v-row>
        </v-col>
        <v-menu
          bottom
          right
          open-on-click
          :offset-y="true"
          content-class="menu mb"
        >
          <template v-slot:activator="{ on }">
            <v-app-bar-nav-icon class="btn_menu" v-on="on"></v-app-bar-nav-icon>
          </template>
          <div class="menu_block">
            <v-btn
              text
              :class="{ active: step > 0 }"
              :disabled="step < 1"
              to="/start"
              v-text="$t('global.start')"
            >
            </v-btn>
            <v-btn
              :class="{ active: step > 1 }"
              :disabled="step < 2 || explainId == null"
              text
              :to="`/explainable/${explainId}`"
              v-text="$t('global.explainable')"
            ></v-btn>
            <v-btn
              text
              :class="{ active: step > 2 }"
              :disabled="step < 3 || optimizeId == null"
              :to="`/optimization/${optimizeId}`"
              v-text="$t('global.optimization')"
            ></v-btn>
          </div>
        </v-menu>
      </v-row>
    </v-card>
  </v-app-bar>
</template>

<script>
export default {
  name: "AppBar",
  computed: {
    oid(){
      return this.$route.params.id;
    },
    toolbarVisibile() {
      return !!this.$route.meta.appbar;
    },
    step() {
      let r = this.$route.name;
      let s = 0;
      switch (r) {
        case "Start":
          s = 1;
          break;
        case "Explainable":
          s = 2;
          break;
        case "Optimization":
          s = 3;
          break;
        case "Download":
          s = 3;
          break;
      }
      return s;
    },
    explainId(){
      return this.$root.explainId;
    },
    optimizeId(){
      return this.$root.optimizeId;
    }
  }
};
</script>